<template>
  <div>
    <p-period-dialog :dialog="periodDialog" @change="val => {periodChangeProcess(val, 'end')}" @close="() => {periodDialog = false}" :dateTime="true" :title="'Previsão'"></p-period-dialog>
    <p-period-dialog :dialog="dateDialog" @change="val => {periodChangeProcess(val, 'created_at')}" @close="() => {dateDialog = false}" :dateTime="true" :title="'Previsão'"></p-period-dialog>
    <v-dialog v-model="dialogFilter" max-width="1200px" persistent scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
      <v-card class="board-card">
        <v-card-title primary-title class="filter-card-title">
          <v-layout wrap>
            <v-flex grow>
              <span class="headline">Defina os filtros</span>
              <!-- <v-tooltip v-if="info" top style="padding-bottom: 50px">
                <v-icon slot="activator" color="black">info</v-icon>
                <span>Será filtrado na consulta de tarefas </span>
              </v-tooltip> -->
            </v-flex>
            <v-flex shrink>
              <v-tooltip bottom>
                <v-btn flat icon align-end color="#000" slot="activator" @click="close">
                  <v-icon>close</v-icon>
                </v-btn>
                <span>Fechar</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="word-break: break-all; padding-top: 0px; padding-bottom: 0px;">
          <v-container grid-list-md class="board_flex_field">
            <v-form ref="formContainer">
              <v-layout row justify-space-between wrap>
                <v-divider></v-divider>
                <!-- terminar exibitiontype -->
                <v-flex xs12 class="board_flex_field" v-if="$vuetify.breakpoint.smAndDown">
                  <v-item-group v-model="editedItem['properties'].exibitionType">
                    <v-item v-for="(opt, index) in itemsExibitionType" :key="index">
                      <v-chip label color="primary" slot-scope="{ active }" @click="onChangeExibition(opt.value)" :outline="!active" :text-color="active ? 'white' : 'primary'">
                        <v-icon left>{{opt.icon}}</v-icon>{{opt.text}}
                      </v-chip>
                    </v-item>
                  </v-item-group>
                </v-flex>
                <v-flex xs12 class="board_flex_field">
                  <v-autocomplete multiple v-model="editedItem['properties'].status" :items="taskFilters.taskStatus" item-text="id_text" item-value="value" label="Status" :filter="filterAutocomplete"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 class="board_flex_field">
                  <v-autocomplete multiple :disabled="disabledField(editedItem['tasktemplate_id'])" validate-on-blur v-model="editedItem['properties'].task_template_id" :items="taskFilters.taskTemplates" item-text="id_text" item-value="id" label="Modelo de Tarefas (POP)" :hint="editedItem['tasktemplate_id'] ? `Este modelo de tarefa está vinculado com sua ${this.translate('table.task_board.title')[0]}` : ''" persistent-hint :filter="filterAutocomplete"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 class="board_flex_field">
                  <v-autocomplete multiple v-model="editedItem['properties'].category" :items="taskFilters.taskCategories" item-text="id_text" item-value="value" label="Categoria" :filter="filterAutocomplete"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 class="board_flex_field">
                  <v-autocomplete multiple :disabled="disabledField(editedItem['team_id'])" validate-on-blur v-model="editedItem['properties'].team_id" :items="taskFilters.taskTeams" item-text="id_text" item-value="id" label="Equipe" :hint="editedItem['team_id'] ? `A ${this.translate('table.task_board.title')[0]} está sendo compartilhado com essa equipe` : ''" persistent-hint :filter="filterAutocomplete"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 class="board_flex_field">
                  <v-autocomplete multiple validate-on-blur v-model="editedItem['properties'].user_id" :items="taskFilters.taskUsers" item-text="id_text" item-value="id" @change="val => onUserChange(val)" label="Responsável" :filter="filterAutocomplete">
                    <template v-slot:item="{ item, tile }">
                      <div class="v-list__tile__action">
                        <v-checkbox :disabled="allLess && item.id !== 'allLess'" :input-value="tile.props.value"></v-checkbox>
                      </div>
                      <div class="v-list__tile__content" >
                          <span :style="`color: ${(allLess && item.id !== 'allLess') ? 'grey': 'black'}`">{{ item.id_text }}</span>
                      </div>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 class="board_flex_field">
                  <v-text-field v-model="editedItem['properties'].id_text" label="Descrição"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 class="board_flex_field">
                  <v-autocomplete multiple v-model="editedItem['properties'].client" :items="taskFilters.taskClients" item-text="id_text" item-value="value" label="Cliente" :filter="filterAutocomplete"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 class="board_flex_field">
                  <v-select multiple v-model="editedItem['properties'].created_by" :items="taskFilters.createdByUser" item-text="id_text" item-value="id" label="Criado Por"></v-select>
                </v-flex>
                <!-- <v-flex xs12 sm6 class="board_flex_field">
                  <v-autocomplete multiple v-model="editedItem['properties'].status" :items="taskFilters.taskStatus" item-text="id_text" item-value="value" label="Status">
                    <template v-slot:item="data">
                      <v-list-tile-content>
                        <v-list-tile-title>{{data.item.id_text}}</v-list-tile-title>
                        <v-list-tile-sub-title v-if="data.item.identifier == 3">Status de conclusão</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>
                </v-flex> -->
                <v-flex xs12 sm6 class="board_flex_field">
                  <v-select
                    clearable
                    :items="dateFilterItems"
                    :value="editedItem['properties'].end_period"
                    :label="'Previsão'"
                    @input="(val) => {changePeriodType(val, 'end')}">
                      <template slot='selection' slot-scope='{ item }'>
                        {{ editedItem['properties']['end_period'] !== 'Período' ? editedItem['properties']['end_period'] : `${editedItem['properties']['end_end'] ? '' : 'Desde '}${editedItem['properties']['end_begin'] ? moment(editedItem['properties']['end_begin']).format('DD/MM/YYYY') : ''} ${editedItem['properties']['end_end'] ? 'Até ' + moment(editedItem['properties']['end_end']).format('DD/MM/YYYY') : ''}`}}
                      </template>
                    </v-select>
                </v-flex>
                <v-flex xs12 sm6 class="board_flex_field">
                  <v-select
                    clearable
                    :items="dateFilterItems"
                    :value="editedItem['properties'].created_at_period"
                    :label="'Data de Criação'"
                    @input="(val) => {changePeriodType(val, 'created_at')}">
                      <template slot='selection' slot-scope='{ item }'>
                        {{ editedItem['properties']['created_at_period'] !== 'Período' ? editedItem['properties']['created_at_period'] : `${editedItem['properties']['created_at_end'] ? '' : 'Desde '}${editedItem['properties']['created_at_begin'] ? moment(editedItem['properties']['created_at_begin']).format('DD/MM/YYYY') : ''} ${editedItem['properties']['created_at_end'] ? 'Até ' + moment(editedItem['properties']['created_at_end']).format('DD/MM/YYYY') : ''}`}}
                      </template>
                    </v-select>
                </v-flex>
                <v-flex xs12 sm6 class="board_flex_field">
                  <v-select v-model="editedItem['properties']['end_status']" :items="translate('value.dashboard_date_status')" label="Status da Previsão" required placeholder="Todas"></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select label="Level" v-model="editedItem['properties']['showTaskLevel']" :items="translate('value.task_filter_level')"></v-select>
                </v-flex>
                <v-flex xs12 sm6 class="board_flex_field">
                  <v-layout justify-space-between>
                    <v-autocomplete :disabled="editedItem['properties'].exibitionType === 2" style="display: inline-block;margin-bottom: 0px;margin-top: 8px;" :items="translate('value.task_order_by')"
                      label="Ordenar Por" v-model="editedItem['properties'].sortBy">
                    </v-autocomplete>
                    <div>
                      <span style="cursor: pointer;" @click="editedItem['properties'].descending = !editedItem['properties'].descending">
                        <v-tooltip style="margin-bottom: -10px;" bottom>
                          <v-icon large slot="activator" style="margin-top: 17px;">{{!editedItem['properties'].descending ? 'vertical_align_bottom' : 'vertical_align_top'}}</v-icon>
                          <span>{{!editedItem['properties'].descending ? 'Crescente' : 'Decrescente'}}</span>
                        </v-tooltip>
                      </span>
                    </div>
                  </v-layout>
                </v-flex>
                <v-flex>
                  <!-- // caso não seja kanban(this.individualFilter['properties']['exibitionType'] !== 2) recarrega os registros, caso seja não recarrega -->
                  <v-switch
                    style="margin-top: 0px;"
                    v-model="editedItem['properties']['showFinalized']"
                    :label="$vuetify.breakpoint.smAndDown ? 'Concluídas' : 'Listar Concluídas'"
                    @change="switchFinalized()"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <small v-if="editedItem['team_id']">Os filtros serão alterados para todas as pessoas que compartilham essa área de trabalho</small>
          <v-spacer></v-spacer>
          <v-btn class="mx-2" color="primary darken-2" @click="save">Salvar</v-btn>
          <v-btn class="mx-2" @click="close">{{textClose}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
  .filter-card-title{
    display: flex;
    justify-content: space-between;
  }
</style>

<script>
  import filterTask from './../../mixin/filterTask'
  import access from './../../mixin/access'
  export default {
    mixins: [filterTask, access],
    data: () => ({
      dialogFilter: false,
      itemsExibitionType: []
    }),
    props: {
      // individualFilter armazena todos os dados atualizados do filtro selecionado -->
      individualFilter: {
        type: Object,
        default: () => { return {} }
      },
      textClose: {
        type: String,
        default: 'Cancelar'
      }
    },
    methods: {
      afterOpenTaskFilter () {
        this.mountExibitionType()
      },
      filterAutocomplete (item, queryText, itemText) {
        const hasValue = val => val != null ? val : ''
        const text = hasValue(itemText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        const query = hasValue(queryText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        return text.indexOf(query) > -1
      },
      mountExibitionType () {
        this.itemsExibitionType = JSON.parse(JSON.stringify(this.translate('value.board_type')))
        // caso o usuário não tenha permissao pra dashboard ou seja uma area de trabalho comparitlhado, não mostra o item de dashboard
        if (!this.checkPermission('dashboard_custom', 'view') || (this.$store.getters[`selectedBoard/values`]['team_id'] > 0)) {
          this.itemsExibitionType.pop()
          // Caso o tipo esteja na dashboard, volta pra lista
          if (this.editedItem['properties'].exibitionType === 3) this.editedItem['properties'].exibitionType = 0
        }
      },
      onChangeExibition (value) {
        this.editedItem['properties'].exibitionType = value
        this.editedItem['properties'].sortBy = value === 2 ? 'status_update' : 'created_at'
        this.editedItem['properties'].descending = true
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/shared/PFilterTaskFields.vue